import React, { useEffect } from "react";
import { Col, Container, Row } from "reactstrap";

// redux toolkit
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { fetchTickets } from "../../slices/apps/ticketSlice";

// sayfalar, modallar vb.
import TicketTable from "./TicketTable";

const SupportChats = () => {
  const dispatch = useDispatch();

  const { ticketsRefresh } = useSelector((state) => {
    return {
      ticketsRefresh: state.ticket.ticketsRefresh,
    };
  }, shallowEqual);

  const fetchData = async () => {
    try {
      await dispatch(fetchTickets());
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchData();
  }, [dispatch, ticketsRefresh]);

  document.title = "Destek Talepleri Listesi | Global Yol Yardım";
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Row>
            <Col xxl={12}>
              <TicketTable />
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default SupportChats;
